module.exports = __webpack_public_path__ + "static/the-anarchy-b52fe8291df468030d930e79ad7f7e40.jpg";